export default function AboutData() {
    return {
        title: "About Life Insurance for Business Owners",
        content: "As a business owner, what day-to-day challenges do you face as you continue to build, protect, and enhance the financial well-being of your business? Life Insurance can be a valuable tool to provide comprehensive and innovative solutions to protect your business, your employees and your lifestyle. As a Navy Federal member, you have access to solutions that are affordable and easy to implement.",
    }
}
